<template>
  <div>
    <transition name="modal">
      <div class="modal__mask">
        <div class="modal__container" :style="'--l-width: ' + width">
          <btn-icon @click.native="$emit('close')" class="modal__close" btn-type="secondary" btn-size="xs">
            <font-awesome-icon :icon="times"/>
          </btn-icon>
          <div class="modal__header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal__body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal__footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BtnIcon from '@/components/shared/buttons/BtnIcon';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';

export default {
  components: {
    BtnIcon,
    FontAwesomeIcon
  },
  props: {
    width: {
      type: String,
      default: '46rem'
    }
  },
  computed: {
    times () {
      return faTimes;
    }
  }
};
</script>

<style lang="scss" vars="{width}">
@import "../../../stylesheets/variables.scss";
.modal {
  &__mask {
    position: fixed;
    z-index: $z-modal-bg;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $white-trans2;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
  }

  &__container {
    margin: 0px auto;
    padding: $sp-margin;
    background-color: $white;
    border: 1px solid $black-trans7;
    border-radius: $radius;
    box-shadow: 0 4px 8px 0 $black-trans8;
    transition: all 0.3s ease;
    color: $bodycolor;
    position: relative;
    width: 18rem;
    @media (min-width: $screen-s) {
      width: 25rem;
    }
    @media (min-width: $screen-s) {
      width: 25rem;
    }
    @media (min-width: $screen-m) {
      width: 37rem;
    }
    @media (min-width: $screen-l) {
      width: var(--l-width);
    }
  }

  &__close {
    position: absolute;
    right: 0.3rem;
    top: 0.3rem;
  }

  &__header {
    margin-top: 0;
  }

  &__body {
    margin: 20px 0;
  }
}

// The following styles are auto-applied to elements with
// transition="modal" when their visibility is toggled by Vue

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal__container,
.modal-leave-active .modal__container {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/dialogs/Modal.vue